import React, {useEffect, useState} from 'react';

import Image from 'next/image';
import { useRouter } from 'next/router';

import {
  Badge,
  Box,
  ClickAwayListener,
  Fab,
  IconButton,
  Popper,
  Slide,
  TextField,
  useMediaQuery,
  Zoom,
} from '@mui/material';

import Autocomplete from '@mui/material/Autocomplete';

import CloseIcon from '@mui/icons-material/Close';

import BuddyIcon from '../components/BuddyIcon';

import cars from '../constants/cars';


const CarPopper = function (props) {
  return (<Popper {...props} placement='top' />)
}


const WaivingBuddy = () => {
  
  const router = useRouter();

  const [buddy, setBuddy] = useState(false);
  const [waving, setWaving] = useState(1);
  const [hooked, setHooked] = useState(false);

  const bigBait = useMediaQuery(theme => theme.breakpoints.up('sm'));

  useEffect(() => {
    const sessionClicked = localStorage.getItem('clickedWaiving');
    if (sessionClicked) {
      setWaving(0);
    };
    setTimeout(() => setBuddy(true), 3000);
  }, [])

  const clickBait = () => {
    setWaving(0);
    setHooked(true);
    localStorage.setItem('clickedWaiving', true);
  }

  const closeHook = () => {
    setHooked(false);
    // setWaving(true);
  }

  const getQuotes = (event, value) => {
    const requestProgress = {
      maxStep: 1,
      car: {
        make: value,
        model: '',
        year: '',
        engine: '',
        vin: '',
      },
      carSearchData: {
        makes: cars,
      },
    };

    localStorage.removeItem('requestProgress');
    localStorage.removeItem('personalQuote');

    localStorage.setItem('requestProgress', JSON.stringify(requestProgress));
    localStorage.setItem('hooked', 1);

    router.push('/request-quotes/?step=0');
  }

  return <>      
    <Zoom in={buddy} timeout={1500} mountOnEnter unmountOnExit>
      <Box
        sx={{
          position: 'fixed',
          bottom: {
            xs: '16px',
            md: '32px',
          },
          right: {
            xs: '16px',
            md: '48px',
          },
          zIndex: 1098
        }}
      >
        {waving === 1 && <Box
          position="absolute"
          zIndex="500"
          top={32}
          left={-16}
        >
          <Image
            alt="Get personalised estimates"
            src="/icons/waiving-hand.svg"
            width={36}
            height={36}
          />
        </Box>}

        <Badge color="error" overlap="circular" badgeContent={waving}>
          <Fab
            color="primary"
            onClick={() => clickBait()}
            sx={{
              backgroundColor: 'primary.light',
              '&:hover': {
                backgroundColor: '#178796',
              },
              width: 64,
              height: 64,
            }}
          >
            <BuddyIcon style={{ fontSize: 40 }} />
          </Fab>
        </Badge>
      </Box>
    </Zoom>

    <Slide direction="left" in={hooked} timeout={750} mountOnEnter unmountOnExit>
      <Box
        sx={{
          position: 'fixed',
          bottom: {
            xs: 8,
            sm: 32
          },
          right: {
            xs: 8,
            sm: 48
          },
          zIndex: 1099
        }}
      >
        <ClickAwayListener onClickAway={() => closeHook()}>
          <Box
            bgcolor="primary.light"
            borderRadius="4px"
            p={2}
            color="white"
            position="relative"
            boxShadow={8}
          >
            <Box
              position="absolute"
              left={bigBait ? -80 : -30}
              top={bigBait ? -50 : 30}
              zIndex={9999}
            >
              <Image
                alt="Get personalised estimates"
                src="/img/personalised-estimates.svg"
                width={bigBait ? 128 : 64}
                height={bigBait ? 170 : 85}
              />
            </Box>

            <Box maxWidth={bigBait ? 260 : 220} ml={bigBait ? 5 : 3}>
              <Box
                fontSize={bigBait ? "h6.fontSize" : "body1.fontSize"}
                fontWeight={500}
                mb={1}
              >Quick cost estimates!</Box>
              <Box
                fontSize={bigBait ? "body2.fontSize" : 14}
                mb={1}
              >Simply choose your car to start receiving quote estimates</Box>

              <Autocomplete
                options={cars}
                openOnFocus={true}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="make"
                    size="small"
                    placeholder="Select your car"
                    variant="outlined"
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                    }}
                    sx={{
                      '& .MuiInputBase-root': {
                        color: 'white',
                      },
                      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                        borderColor: 'white',
                        '&:hover': {
                          borderColor: 'white'
                        }
                      },
                      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: 'white',
                      },
                      '& label': {
                        color: 'white',
                      },
                      '& label.Mui-focused': {
                        color: 'white',
                      },
                    }}
                  />
                )}
                onChange={getQuotes}
                PopperComponent={CarPopper}
                sx={{
                  '& .MuiAutocomplete-popupIndicator': {
                    color: 'white',
                  }
                }}
              />
            </Box>
          
            <Box
              position="absolute"
              right={-10}
              top={-10}
              zIndex={9999}
            >
              <IconButton onClick={() => closeHook()} size="large">
                <CloseIcon style={{ color: '#efefef' }} />
              </IconButton>
            </Box>
          </Box>
        </ClickAwayListener>
      </Box>
    </Slide>
  </>;
}

export default WaivingBuddy;
